import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeft from '@domain-group/fe-co-icon/lib/js/chevron-left';
import * as styles from './back-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BackButton = _ref => {
  var onClick = _ref.onClick;
  return ___EmotionJSX("button", {
    onClick: onClick,
    css: styles.button,
    type: "button"
  }, ___EmotionJSX(ChevronLeft, {
    size: "custom",
    css: styles.buttonIcon
  }), ___EmotionJSX("div", {
    css: styles.buttonLabel
  }, "back"));
};
BackButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default BackButton;